export function isNum(value) {
  if (value === null || value === undefined || value === '') {
    return false;
  }

  const integer = Number(value);

  if (isNaN(integer)) {
    return false;
  }

  return true;
}
